<template>
  <Card head title="用户登录" class="data-base" :more="false">
    <div v-if="loggedIn">
      <div class="log-in mt-10">
        <div>
          <p class="mb-8">你好，欢迎来到福州城投采购门户！</p>
          <v-btn class="button px-7 mb-6 blue" @click="clickLog('https://fuzhouctyc.com/workbench/sso/login.jsp')">进入工作台</v-btn>
          <v-btn class="button px-7 mb-6" @click="clickLog('/yuncai/caslogout')">注销</v-btn>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="content pt-4 mb-3" v-if="displayInOnline">
        <div v-for="item in list" class="item pa-0 pt-5 flex-grow-1" :key="item.id" @click="onClickItem(item)">
          <Item :item="item"></Item>
        </div>
      </div>
      <div class="content pt-4" v-else>
        <div v-for="item in list" class="item pa-0 pt-5 flex-grow-1" :key="item.id" @click="onClickItem(item)">
          <Item :item="item"></Item>
        </div>
      </div>
    </div>
  </Card>
</template>

<script>
import Card from '@/components/UI/Card'
import BDCIcon1 from '@/assets/icons/BDCIcon1.png'
import BDCIcon2 from '@/assets/icons/BDCIcon2.png'
import BDCIcon3 from '@/assets/icons/BDCIcon3.png'
import BDCIcon4 from '@/assets/icons/BDCIcon4.png'
import BDCIcon5 from '@/assets/icons/BDCIcon5.png'
import Item from './Item'
export default {
  name: 'List',
  components: {
    Item,
    Card
  },
  data: () => {
    return {
      list: [{
        id: 0,
        text: '供应商',
        path: '',
        imgSrc: BDCIcon2,
        bg: '#4c9bfb'
      }, {
        id: 1,
        text: '采购人',
        path: '',
        imgSrc: BDCIcon1,
        bg: '#52c51a'
      }, {
        id: 2,
        text: '采购代理',
        path: '',
        imgSrc: BDCIcon3,
        bg: '#ffad57'
      }, {
        id: 3,
        text: '评审专家',
        path: '',
        imgSrc: BDCIcon4,
        bg: '#fe5f56'
      }, {
        id: 4,
        text: '监督机构',
        path: '',
        imgSrc: BDCIcon5,
        bg: '#fe5f56'
      }]
    }
  },
  computed: {
    loggedIn () {
      if (window.document.cookie.indexOf('tenantid') >= 0) {
        return true
      } else {
        return false
      }
    },
    displayInOnline () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
        case 'md':
          return true
        case 'lg':
        case 'xl':
          return false
      }
      return false
    }
  },
  methods: {
    onClickItem (item) {
      if (window.document.cookie.indexOf('tenantid') >= 0) {
        window.location.href = '/workbench/sso/login.jsp'
      } else {
        if (item.text === '供应商') {
          this.$router.push('/LoginDetail')
        } else {
          window.location.href = 'https://euc.yonyoucloud.com/cas/login?sysid=ipu&ipuid=fzct-zs&service=https%3A%2F%2Ffuzhouctyc.com%2Fyuncai%2FSSO%2Flogin.jsp%3Fr%3DL3l1bmNhaS9wb3J0YWw'
        }
      }
    },
    clickLog (item) {
      window.location.href = item
    }
  }
}
</script>

<style lang="scss" scoped>
.log-in {
  text-align: center;
  border: 1px solid #3172b770;
  padding: 15px;
  .button {
    width: 100%;
    background-color: #fff!important;
    color: #5aaef2;
    border: 1px solid #f5f5f5;
    &.blue {
      background-color: #3171b7 !important;
      color: #fff;
    }
  }
  a {
    text-decoration: none;
    text-align: right;
    display: block;
  }
  span {
    display: block;
    width: 100%;
    text-align-last: left;
  }
}
.data-base {
  .card-title {
    color: #fff;
  }
  @media (max-width: 1263px) {
    .item {
      margin-right: 15px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .content {
    &.d-flex {
      .item:not(:last-child) {
        // margin-right: 26px;
      }
    }
    &:not(.d-flex) {
      &::after {
        content: '';
        display: block;
        clear: both;
      }
      .item {
        width: 100%;
      }
    }
  }
}
</style>
